// Types for the platform (system) admin persona — a wholly separate auth
// surface from the org app. Hand-written from the Go API contract in
// docs/design/platform-admin-persona-lld.md. Do NOT import from
// features/auth/types — platform tokens/principals are never org-scoped.

export interface PlatformPrincipal {
  id: string;
  full_name: string;
}

export interface PlatformTokenPair {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

export interface PlatformLoginResult {
  tokens: PlatformTokenPair;
  principal: PlatformPrincipal;
}

// ---- Orgs --------------------------------------------------------------

export interface OrgSummary {
  id: string;
  name: string;
  code: string;
  timezone?: string;
  currency?: string;
  created_at?: string;
  updated_at?: string;
}

// ---- Provisioning --------------------------------------------------------

export interface ProvisionOrgFields {
  name: string;
  code: string;
  timezone?: string;
  currency?: string;
}

export interface ProvisionAdminFields {
  full_name: string;
  phone: string;
  username: string;
  password: string;
}

export interface ProvisionOrgInput {
  org: ProvisionOrgFields;
  admin: ProvisionAdminFields;
}

export interface ProvisionOrgResult {
  org: {
    id: string;
    name: string;
    code: string;
  };
  admin: {
    id: string;
    full_name: string;
    username: string;
  };
}

// ---- Error type (mirrors features/auth/types.ApiError) ------------------

export class PlatformApiError extends Error {
  status: number;

  constructor(
    public readonly code: string,
    message: string,
    status = 0,
  ) {
    super(message);
    this.name = 'PlatformApiError';
    this.status = status;
  }
}
